export var formatarCpf = function (valorDigitado) {
    if (!valorDigitado)
        return "";
    var valoresNumericos = valorDigitado.replace(/\D/g, "");
    var cpfComMascara = valoresNumericos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    return cpfComMascara;
};
export var formatarTelefone = function (valorDigitado) {
    if (!valorDigitado)
        return "";
    var valoresNumericos = valorDigitado.replace(/\D/g, "");
    var telefoneComMascara = valoresNumericos.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    return telefoneComMascara;
};
